import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  moveDocument(request: Boundaries["moveDocument"]["request"]): void;
}

function useMoveDocument(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isMoveDocumentRequestPending),
    isRequestSuccess: useSelector(selector.isMoveDocumentRequestSuccess),
    isRequestFailure: useSelector(selector.isMoveDocumentRequestFailure),
    moveDocument: core.moveDocument,
  };
}

export { useMoveDocument };
